import React, { useState, useEffect , useRef } from 'react';
import {Button, Card, CardBody, Col, Container,CardHeader, 
  Row, Input, FormGroup, Label,Collapse, Nav, NavItem, NavLink, 
  Spinner, TabContent, TabPane, Modal, ModalHeader,
   ModalBody, ModalFooter} from 'reactstrap';
import { Video, Music, FileText , } from 'react-feather';
import AddResourceCard from './AddResourceModal';
import AddTopicCard from './AddTopicModal';
import classnames from 'classnames'; // To handle active tab classes
import { LiaChalkboardTeacherSolid } from "react-icons/lia";
import { CiEdit } from "react-icons/ci";
import {  PiStudentDuotone } from "react-icons/pi";
import { TbDownloadOff } from "react-icons/tb";
import SonglistCard from './SongListModal';
import { Trash ,Eye, Download } from 'react-feather';
import AddAssignmentCard from './AddAssignment';
import {ChevronDown} from 'react-feather';
import ReactQuill, {Quill} from 'react-quill';
import PreviewComponent from './PreviewComponent';
import AddLevelModal from './AddLevelModal';
import { Plus } from 'react-feather';
import { MdOutlineCancel } from "react-icons/md";
import LessonRubrics from './lessonRubrics';
import { tagsMap } from './tags';
import Select from "react-select";
import { LessontagsMap } from './LessonTags'; 
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';



import Search from './search';
import { toast } from "react-toastify";
import './style.scss';
import VideoResourceCard from './VideoResourceCard';
import AddLessonModal from './AddLessonModal'; 
import { addLesson, getLessons, getTopics, addTopic, signedURL, uploadResourse, getTopicWithResource, addAssignment, updateLesson, removeTopicResource, addExistingResourceToTopic, deleteAssignmentFromTopic, editTopic, addTagsResoures, editResourceTags, addResource , isDownloadable} from '../../../../Api/lms/apiUtils'; 
import { _addResource } from '../../../../Api/lms/utility'; 
import { H1, H2, H3, H4, H5,H6 } from '../../../../AbstractElements';


interface Resource {
  resource_id: number;
  resource_name: string;
  type: string;
  url: string;
  tags: any;
  is_downloadable: any;
  display_name?: any;
  fileUrl?: string;
}

interface Topic {
  description:any;
  topic_name: string;

topic_number: any;

  topic_id: number;
  resources?: Resource[];
}

interface Song {
  
}

interface Lesson {
  lesson_number: number;
  topics: Topic[];
  level_id: number;
}

interface ArtiumCourseManagerProps {
  selectedCourse: string;
  courseDetail: any;
  selectedLevel: string;
  courseLevels: any;
  setCourses:any;
  fetchCourses:any;
  setSelectedCourse:any
}

// const Clipboard = Quill.import('modules/clipboard');
// class CustomClipboard extends Clipboard {
//   onPaste(e) {
//     super.onPaste(e); // Use default behavior
//     // Add additional parsing here if necessary
//   }
// }
// Quill.register('modules/clipboard', CustomClipboard);
// const modules = {
//   clipboard: {
//     matchVisual: false, // Preserve formatting during paste
//   },
// };

const ReplaceableResourceCard: React.FC<{
  resource: Resource;

  onSave: (updatedResource: Resource) => void;
  fetchTopicWithResources: () => void;
  onDelete: (resource: Resource) => void;
  onChecked:(resource: Resource) => void;
}> = ({ resource, onSave, onDelete, fetchTopicWithResources, onChecked}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [newFile, setNewFile] = useState<File | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false); // Manage preview state
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
const [resourceToDelete, setResourceToDelete] = useState<Resource | null>(null);
const [isEditTagsModalOpen, setIsEditTagsModalOpen] = useState(false);
const { tagsList, isLoading: tagsLoading } = tagsMap()


const [selectedEditTags, setSelectedEditTags] = useState<any[]>([]);
useEffect(() => {
  const matchedTags = Array.isArray(resource.tags)
    ? resource.tags.map((tagName: any) => {
        const matchedTag = tagsList.find((tag) => tag.name === tagName);
        return matchedTag
          ? { label: matchedTag.name, value: matchedTag.id }
          : null; 
      }).filter(Boolean) 
    : [];

  setSelectedEditTags(matchedTags); // Update state only with valid tags
}, [resource.tags, tagsList]);


  // const { tagsList, isLoading: tagsLoading } = tagsMap()
  const tagOptions = tagsList.map(tag => ({ value: tag.id, label: tag.name }));


const handleTogglEdit = () => setIsEditTagsModalOpen(!isEditTagsModalOpen);

  const handleToggle = () => setIsOpen(!isOpen);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setNewFile(e.target.files[0]);
    }
  };

  const handleSaveTags = async () => {
    try {
      // Transform selectedEditTags to ensure all are in the form of IDs
      const tagIds = selectedEditTags.map((tag: any) => {
        // If the tag has an ID, use it; otherwise, find the ID by the name
        if (typeof tag.value === 'number') {
          return tag.value; // Already an ID
        } else {
          // Find the tag in tagsList by name and return its ID
          const matchedTag = tagsList.find(t => t.name === tag.value || t.name === tag.label);
          return matchedTag ? matchedTag.id : tag.value; // If not found, use the original value (fallback)
        }
      });
  
      const data = {
        tagIds,
        resourceId: resource.resource_id,
      };
  
      const response = await editResourceTags(data);
  
      if (response.success) {
        toast.success('Tags updated successfully!');
        setIsEditTagsModalOpen(false);
        fetchTopicWithResources();    
      } else {
        toast.success('Tags updated successfully!');
        fetchTopicWithResources(); 
        setIsEditTagsModalOpen(false);  
        
      }
    } catch (error) {
      console.error('Error updating tags:', error);
      toast.error('Error updating tags. Please try again.');
    }
  };
  

  const handlePreviewToggle = () => {
    setIsPreviewOpen(!isPreviewOpen);
  };

  const handleDownload = () => {
    const fileUrl = resource.fileUrl || resource.url;

    if (!fileUrl?.trim()) {
      toast.error('Download URL not available for this resource');
      return;
    }

    window.open(fileUrl, '_blank', 'noopener,noreferrer');
  };

  const openDeleteModal = (resource: Resource) => {
    setResourceToDelete(resource);
    setIsDeleteModalOpen(true);
  };
  
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setResourceToDelete(null);
  };
  

  return (
    //this is code for collapse 
    <>
<Card style={{ maxHeight: '80vh', overflowY: 'auto', marginTop: '10px' }}>
      <CardBody>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', textAlign:"left" }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div onClick={handleToggle} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
              {resource.type === 'video' && <Video color="grey" />}
              {resource.type === 'audio' && <Music color="grey" />}
              {resource.type === 'article' && <FileText color="grey" />}
              {resource.type === 'pdf' && <FileText color="grey" />}
              {resource.type === 'mp3' && <Music color="grey" />}
              {resource.type === 'mp4' && <Video color="grey" />}
              {resource.type === 'mov' && <Video color="grey" />}

              <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{resource.display_name}</span>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button color="secondary" onClick={handlePreviewToggle} title="Preview resource">
                <Eye size={18} />
              </Button>
              <Button color="secondary" onClick={handleDownload} title="Download resource">
                <Download size={18} />
              </Button>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
  <span>
Downloadable
  </span>
  
  <Input 
    className='levelChk'
    type="checkbox"
    style={{ height: "20px", width: "20px" }}
    title={resource.is_downloadable 
      ? "Resource is downloadable from dashboard" 
      : "Resource is not downloadable from dashboard"
    }
    checked={resource.is_downloadable}
    onChange={() => onChecked(resource)}
  />
</div>
             
                 
              <Button color="secondary" onClick={() => openDeleteModal(resource)}>
                <Trash size={18} />
              </Button>
            </div>
          </div>
          {Array.isArray(resource.tags) && resource.tags.filter(tag => tag).length > 0 && (
            <div>
              <strong>Tags:</strong>
              <div style={{ marginLeft: '10px' }}>
                {resource.tags
                  .filter(tag => tag)
                  .map((tag, index) => (
                    <div key={index}>
                      {index + 1}. {tag}
                    </div>
                  ))}
              </div>
              
            </div>
            
          )}
          <Button style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginLeft:"-19px" }} color="link" onClick={handleTogglEdit} >
                  Edit Tags
                </Button>
        </div>

        <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal}>
          <ModalHeader toggle={closeDeleteModal}>Confirm Delete</ModalHeader>
          <ModalBody>
            Are you sure you want to delete the resource: <strong>{resource.resource_name}</strong>?
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              onClick={() => {
                onDelete(resource);
                setIsDeleteModalOpen(false); // Close the modal
              }}
            >
              Delete
            </Button>
            <Button color="secondary" onClick={closeDeleteModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        {/* Edit Tags Modal */}
        <Modal isOpen={isEditTagsModalOpen} toggle={handleTogglEdit}>
          <ModalHeader toggle={handleTogglEdit}>Edit Tags for {resource.display_name}</ModalHeader>
          <ModalBody>
          <Select
  isMulti
  options={tagOptions}
  value={selectedEditTags.length > 0 ? selectedEditTags : null} // Ensure value is null if no tags
  onChange={(options) =>
    setSelectedEditTags(Array.isArray(options) ? [...options] : [])
  }
  placeholder="Choose tags for resources"
/>


          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleSaveTags}>
              Save
            </Button>
            <Button color="secondary" onClick={handleTogglEdit}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </CardBody>
    </Card>

    {/* Preview Component */}
    <PreviewComponent
      resource={resource}
      isOpen={isPreviewOpen}
      onClose={handlePreviewToggle} // Close preview when necessary
    />
  </>
  );
};


const ArtiumCourseManager: React.FC<ArtiumCourseManagerProps> = ({  courseLevels,courseDetail, selectedCourse = "Course Title", selectedLevel, setSelectedCourse,  setCourses }) => {
  console.log("coursse", courseDetail);
  const [selectedTopic, setSelectedTopic] = useState<any | null>(null);
  const [isAddingResources, setIsAddingResources] = useState<boolean>(false);
  const [clickTopicModal, setClickTopicModal ]=useState<boolean>(false);
  const[isAddingSong , setAddingSong]  = useState<boolean>(false);
  const [expandedLesson, setExpandedLesson] = useState<number | null>(null);
  const [isAddingTopic, setIsAddingTopic] = useState<boolean>(false);
  const [isAddingLesson, setIsAddingLesson] = useState<boolean>(false);
  const [isAddingAssignment, setIsAddingAssignment] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [summary, setSummary] = useState<any>('');
  const [lessonObjective, setLessonObjective] = useState<string>('');
  const [lessonName, setLessonName]= useState<any>('');
  const [lessonNumber, setLessonNumber]= useState<any>('');
  const [lessonProcedure, setLessonProcedure] = useState<string>('');
  const [lessonClosure, setLessonClosure] = useState<string>('');
  const [selectedTopicIndex, setSelectedTopicIndex] = useState<any| null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isPreviewVisible, setPreviewVisible] = useState(false); // State to toggle the preview
  const [previewResource, setPreviewResource] = useState(null);
  const [newResourceType, setNewResourceType] = useState<'video' | 'audio' | 'pdf'>('video');
  const [selectedFiles, setSelectedFiles] = useState<FileList | null>(null);
;  const [resources, setResources] = useState<Resource[]>([]);
  const [learningOutcomes, setLearningOutcomes] = useState<any>('');
  const [existingProcedureId, setExistingProcedureId] = useState<any>('');
  const [ procedureFile, setProcedureFile] = useState<any>('');
  const [ procedureUrl, setProcedureUrl ] = useState<any>('');
  const [isIsframeLoading, setIsFrameLoading] = useState(true);

  


  const [lessongTags, setLessongTags] = useState<any>([]);


  const [lessons, setLessons] = useState<LessonType[]>([]);
  const [displayName, setDisplayName] = useState<string>('');
  const [topics, setTopics] = useState([]);
  
  const [selectedTags, setSelectedTags] = useState<number[]>([]);
  const [savedTopic, setSavedTopic] = useState({}); // for addassignment 
  const [activeTab, setActiveTab] = useState<number>(courseDetail?.levels[0]?.level_id); // Set the first level as default
  const [isOpen, setIsOpen] = useState(false); // State for managing collapse
  const [isOpenAssign, setIsOpenAssign] = useState(false);
  const [isOpenResource, setIsOpenResource] = useState(false);  // State to handle collapse toggle
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [resourceFiles, setResourceFiles] = useState<FileList | null>(null);
  const [editorContent, setEditorContent] = useState<string>('');
  const [isUploading, setIsUploading] = useState(false); 
  const [updatedDescription, setUpdatedDescription] = useState((selectedTopic as any)?.topic.description);
  const [topicName, setTopicName] = useState<any>('');

  const [topicNumber, setTopicNumber] = useState<any>('');
  const [updatedCourseDetail, setUpdatedCourseDetail] = useState(courseDetail);
    const [isExtended, setIsExtended] = useState<boolean>(false); 
    const [artiumGrade, setArtiumGrade] = useState<boolean>(false);
    const [trinityGrade, setTrinityGrade] = useState<boolean>(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
const [assignmentToDelete, setAssignmentToDelete] = useState<{ topicId: number; assignmentId: number } | null>(null);
const [isHovered, setIsHovered] = useState(false);
const [selectedResourceId, setSelectedResourceId] = useState<number | null>(null);
const [isModalOpen, setIsModalOpen] = useState(false);
const [currentView, setCurrentView] = useState('');
const [isAddLevelModalOpen, setIsAddLevelModalOpen] = useState(false);
const [isFileModalOpen, setFileModalOpen] = useState(false);
const [currentLessonId, setCurrentLessonId] = useState<number | null>(null);
const [fileInputs, setFileInputs] = useState<{ file: File; displayName: any }[]>([]);
const [nestedTab, setNestedTab] = useState<number>(1);
const {lessonTagsList, isLessonLoading: tagsLessonLoading } = LessontagsMap()
const [isLessonModalOpen, setIsLessonModalOpen] = useState(false);

const handleToggleModal = () => setIsLessonModalOpen(!isModalOpen);
const closeLessonModal = ()=>setIsLessonModalOpen(isModalOpen);
const LessonTagOptions =lessonTagsList.map((LessonTagMap) => ({ value: LessonTagMap.name, label: LessonTagMap.name }));
  const { tagsList, isLoading: tagsLoading } = tagsMap()

const tagOptions = tagsList.map((tag) => ({ value: tag.id, label: tag.name }));
const toggleModal = () => setIsModalOpen(!isModalOpen);

const handleOpenDeleteModal = (resource_id: number) => {
  setSelectedResourceId(resource_id);
  toggleModal();
};



type LessonType = {
  lesson_id: number;
  lesson_number: string;
  lesson_name: string;
  summary: string;
  objective: string;
procedure_id:any;
  lesson_procedure: string;
  lesson_closure: string;
  outcome: string;
  // Add other properties as needed
};

const toggleFileModal = () => setFileModalOpen(!isFileModalOpen);
const toggleCollapseResource = () => setIsOpenResource(!isOpenResource); 

  const toggleCollapse = () => setIsOpenAssign(!isOpenAssign); 

  const toggle = () => setIsOpen(!isOpen)

  const filteredLessons = lessons.filter((lesson:any) => lesson.level_id === activeTab);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files);
      const inputs = selectedFiles.map(file => ({
        file,
        displayName: file.name.split('.')[0] // Initial display name
      }));
      setFileInputs(inputs);
    }
  };

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  const updateCourseLevels = (newLevels : any) => {
    setUpdatedCourseDetail((prevDetail : any) => ({
      ...prevDetail,
      levels: [...prevDetail.levels, ...newLevels],
    }));
  };
 
  const openDeleteModal = (topicId: number, assignmentId: number) => {
    setAssignmentToDelete({ topicId, assignmentId });
    setIsDeleteModalOpen(true);
  };
  (alert)
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setAssignmentToDelete(null);
    // setCurrentView("");
 
  };
  
  const toggleAddLevelModal = () => setIsAddLevelModalOpen(!isAddLevelModalOpen);
  const toggleTab = async (tab: number) => {
    if (activeTab !== tab) {
      setIsLoading(true);
      await resetview(); 
      setActiveTab(tab); 

      setIsLoading(false); 
    }
  };
  const fileExtension = procedureUrl ? procedureUrl.split('.').pop()?.toLowerCase() : null;


  const isPdf = fileExtension === 'pdf';
  const isAudio = ['mp3', 'wav', 'm4a'].includes(fileExtension || '');
  const isVideo = ['mp4', 'mov', 'avi', 'mkv'].includes(fileExtension || '');

  const getMimeType = (extension: string | undefined) => {
    switch (extension) {
      case 'mp3':
        return 'audio/mpeg';
      case 'wav':
        return 'audio/wav';
      case 'm4a':
        return 'audio/mp4'; // Common MIME type for M4A
      case 'mp4':
        return 'video/mp4';
      case 'mov':
        return 'video/quicktime';
      case 'avi':
        return 'video/x-msvideo';
      case 'mkv':
        return 'video/x-matroska';
      default:
        return '';
    }
  }

  // const Clipboard = Quill.import('modules/clipboard');
  // class CustomClipboard extends Clipboard {
  //   onPaste(e : any) {
  //     super.onPaste(e); // Use default behavior
  //     // Add additional parsing here if necessary
  //   }
  // }
  // Quill.register('modules/clipboard', CustomClipboard);
  // const modules = {
  //   clipboard: {
  //     matchVisual: false, // Preserve formatting during paste
  //   },
  // };
  
  const toggleNestedTab = (tabId: number) => {
    if (nestedTab !== tabId) setNestedTab(tabId);
  };

  useEffect(() => {
    if (selectedTopic) {
      console.log( selectedTopic.topic.topic_id,"topicid")
      console.log('Selected Topic Updated:', selectedTopic);
    } else {
      console.log('No data in selectedTopic');
    }
  }, [selectedTopic]); 
 

  const resetview = () => {
    return new Promise((resolve) => {
      setAddingSong(false);
      setIsAddingResources(false);
      setIsAddingTopic(false);
      setIsAddingLesson(false);
      setExpandedLesson(null);
      setIsEditing(false);
      setSummary('');
      setLearningOutcomes('');

      setLessongTags([]);

      setSelectedTopic(null);
      setTopics([]);
    // Clear topics
      setLessons([]);

      // Simulate a delay to show the loader, then resolve the promise
      setTimeout(() => resolve(true), 500); // Adjust delay as needed
    });
  };
  const fetchLessons = async () => {
    try {
      const response = await getLessons(activeTab);
      if (response.lessons?.length) {
        setLessons(response.lessons);
      } else {
        setLessons([]);
      }
    } catch (error) {
      console.error('Error fetching lessons:', error);
      setLessons([]);
    }
  };

  const courseId = courseDetail?.course_id;

  useEffect(() => {
    if (!courseId) return;
    setUpdatedCourseDetail(courseDetail);
    const firstLevelId = courseDetail?.levels?.[0]?.level_id;
    if (firstLevelId != null) {
      setActiveTab(firstLevelId);
    }
  }, [courseId, courseDetail]);

  useEffect(() => {
    if (!activeTab || !courseId) return;

    let cancelled = false;

    const loadLessonsForCourse = async () => {
      setTopics([]);
      setSelectedTopic(null);
      setExpandedLesson(null);
      setCurrentView('');
      setIsAddingLesson(false);
      setIsAddingTopic(false);
      setIsAddingResources(false);
      setAddingSong(false);
      setIsEditing(false);

      try {
        const response = await getLessons(activeTab);
        if (cancelled) return;
        setLessons(response.lessons?.length ? response.lessons : []);
      } catch (error) {
        if (!cancelled) {
          console.error('Error fetching lessons:', error);
          setLessons([]);
        }
      }
    };

    loadLessonsForCourse();

    return () => {
      cancelled = true;
    };
  }, [activeTab, courseId]);
  const fetchTopics = async (lessonId:any, topic:any = "") => {
    try {
      const response = await getTopics(lessonId);
      if (response.topics?.length) {
        setTopics(response.topics); // Set topics from API
        if(topic){
          let _index;
          let _topic = {};
          response.topics.map((t:any, i:any) => {
            if(t.topic_id === topic.topic_id){
              _index = i;
              _topic = t;
            }
          });
          handleTopicClick((_topic as any), _index);
        }
      } else {
        setTopics([]); 
        console.error('Failed to fetch topics:', response.message);
      }
    } catch (error) {
      console.error('Error fetching topics:', error);
    }
  };
  const handleEditLesson = (lessonId: number) => {
    const lesson = lessons.find((l: any) => l.lesson_id === lessonId);
    if (lesson) {
      setSummary((lesson as any).summary);
      setLessonObjective((lesson as any).objective);
      setLearningOutcomes(((lesson as any) as any).outcome);
      setLessonName((lesson as any).lesson_name);
      setLessongTags((lesson as any).tags);
      setLessonNumber((lesson as any).lesson_number);    
      setLessonProcedure(((lesson as any) as any).lesson_procedure);
      setLessonClosure((lesson as any).lesson_closure);
  
  setProcedureUrl((lesson as any).procedureUrl);
      setProcedureFile(null); // Clear the procedure file (if any new upload needed)
  
      // Fallback to ensure procedure ID is handled correctly
      const procedureId = lesson.procedure_id ?? null; // Use null if undefined
      console.log('Setting Existing Procedure ID:', procedureId);
      setExistingProcedureId(procedureId);
  
      setIsEditing(true);
      setCurrentLessonId(lessonId);
      setCurrentView('view_edit_Lesson');
    }
  };
  

  
  const handleChange = (content: string, delta: any, source: string, editor: any) => {
    if (source === 'user') {
      // Check if the delta contains a paste operation
      const pastedContent = delta.ops?.some((op: any) => op.insert && typeof op.insert === 'string');
      if (pastedContent) {
        // Apply Heading 3 formatting to the entire pasted content
        setTimeout(() => {
          const quill = editor.getEditor();
          quill.format('header', 3);
        }, 0); // Defer formatting to ensure paste operation is completed
      }
    }
    setEditorContent(content);
  };

  const handleSave = async () => {
    if (
      !lessonNumber ||
      !lessonName ||
      !summary ||
      !lessonObjective ||
      !learningOutcomes ||
      !lessonProcedure ||
      !lessonClosure
    ) {
      toast.error('Please fill all the mandatory fields');
      return;
    }
  
    // setIsButtonDisabled(true); // Disable button to prevent duplicate submissions
    const selectedTagNames = lessongTags;
    try {
      let procedureId = existingProcedureId; // Default to the existing procedure ID
  
      if (procedureFile) {
        // New file detected; upload and replace the existing procedure ID
        console.log('New procedure file detected. Starting upload...');
        const fileExtension = procedureFile.name.split('.').pop();
        const fileName = procedureFile.name.split(' ').join('_');
  
        // Get a signed URL for the file upload
        const signedUrlResponse = await signedURL({ fileName, fileType: fileExtension });
        if (signedUrlResponse.status === 200) {
          const { signedUrl, fileName: resourceName } = signedUrlResponse.data;
  
          // Upload the file
          const uploadResponse = await uploadResourse(signedUrl, procedureFile);
          if (uploadResponse.status === 200) {
            console.log('File uploaded successfully. Saving resource...');
  
            // Save the file as a resource and get the new procedure ID
            const resourceResponse = await addResource({
              resourceName,
              displayName: procedureFile.name,
              type: fileExtension,
              description: '',
              url: '',
            });
  
            if (resourceResponse.status === 200 && resourceResponse.data.resource.length > 0) {
              procedureId = resourceResponse.data.resource[0].resource_id; // Update to the new resource ID
              console.log('Resource saved successfully with new procedure ID:', procedureId);
            } else {
              console.error('Failed to save resource to server:', resourceResponse);
              toast.error('Error saving resource to server.');
              return;
            }
          } else {
            console.error('Failed to upload file to server:', uploadResponse);
            toast.error('Error uploading file.');
            return;
          }
        } else {
          console.error('Failed to get signed URL:', signedUrlResponse);
          toast.error('Error getting signed URL.');
          return;
        }
      } else if (!existingProcedureId) {
        // No existing file and no new file provided; procedureId remains null
        console.log('No procedure file provided and no existing procedure ID.');
        procedureId = null;
      } else {
        // No new file provided; retain the existing procedure ID
        console.log('No new file provided. Keeping existing procedure ID:', existingProcedureId);
      }
  
      // Prepare request parameters
    
      const reqParam = {
        levelId: activeTab,
        lessonNumber,
        lessonName,
        summary,
        objective: lessonObjective,
        lessonProcedure,
        lessonClosure,
        outcome: learningOutcomes,
        tags: selectedTagNames,
        procedureId, // Pass the correct procedure ID (new or existing)
      };
  
      console.log('Saving lesson with request parameters:', reqParam);
  
      // Call the API to update the lesson
      const response = await updateLesson(currentLessonId, reqParam);
      if (response.status === 200) {
        toast.success('Lesson updated successfully');
  
        await fetchLessons();
        const updatedLessons = lessons.map((lesson) => {
          if (lesson.lesson_id === currentLessonId) {
            return {
              ...lesson,
              lesson_number: lessonNumber,
              lesson_name: lessonName,
              summary: summary,
              objective: lessonObjective,
              lesson_procedure: lessonProcedure,
              lesson_closure: lessonClosure,
              outcome: learningOutcomes,
              tags: selectedTagNames,
              procedure_id: procedureId, // Update the procedure ID in local state
              procedureUrl: procedureFile ? URL.createObjectURL(procedureFile) : '', // Update the procedure URL
            };
          }
          return lesson;
        });
  
        setLessons(updatedLessons);
        setIsEditing(false);
        setCurrentLessonId(null);
      } else {
        console.error('Failed to update lesson:', response);
        toast.error(`Failed to update lesson: ${response.data.message}`);
      }
    } catch (error) {
      console.error('Error updating lesson:', error);
      toast.error('An error occurred while updating the lesson.');
    } finally {
      // setIsButtonDisabled(false); // Re-enable button
    }
  };
  
  


  
  const handleToggleSongCard = () => {
    setAddingSong(false);

  };
  const handleAddSongClick = () => {
    // setIsUploading(true);
    setCurrentView('view_level_song');  
    setAddingSong(true); // Handler to toggle the visibility of the SongListCard
  };

const OnCancelResourse =  () =>{
  setIsAddingResources(false);

}
const handleAddExistingResourceToTopic = async (resources: any) => { 
  try {
    const response = await addExistingResourceToTopic(
      {
        "topicId": selectedTopic.topic.topic_id,
        "resourceIds": resources.map((resource: any) => ( resource.resource_id))
     }
    );
    if (response.status === 200) {
      console.log('Resource added successfully');
      toast.success ('Resource added successfully');
      fetchTopicWithResources(selectedTopic.topic.topic_id);
      setIsUploading(false);
      // const updatedTopic = {
      //   ...selectedTopic,
      //   resources: [...(selectedTopic.resources || []), ...[resources]],
        
      // };
      // setSelectedTopic(updatedTopic);
    } else {
      console.error('Failed to add resource:', response.data.message);
    }
  } catch (error) {
    console.error('Error adding resource:', error);
  }
}

const fileInputRef = useRef<HTMLInputElement | null>(null);

const clearFileInput = () => {
  if (fileInputRef.current) {
    fileInputRef.current.value = ''; // This resets the input field.
  }
};
const handleAddResources = async () => {
  if (fileInputs.length === 0 || !selectedTopic) {
    toast.error('Please select files and a topic.');
    return;
  }

  setIsUploading(true);

  try {
    let addedResources = [];


    for (const input of fileInputs) {
      const { file, displayName } = input;

      let resourceRes = await _addResource([file], displayName);
      if (resourceRes) {
        const resourceId = resourceRes.resource_id;

      
        if (selectedTags.length > 0) {
          const tagRes = await addTagsResoures({
            tagIds: selectedTags,
            resourceId: resourceId,
          });
          console.log("selected",selectedTags)
          if (tagRes) {
            toast.success(`Tags assigned to "${displayName}" successfully`);
  
          } else {
            // toast.error(`Failed to assign tags to "${displayName}"`);

          }
        }

        addedResources.push(resourceRes);
      }
    }
    const resourceIds = addedResources.map((res) => res.resource_id);

    let topicRes = await addExistingResourceToTopic({
      topicId: selectedTopic.topic.topic_id,
      resourceIds: resourceIds,
    });

    if (topicRes.status === 200) {
      toast.success('Resources added successfully');

 
      const updatedTopic = {
        ...selectedTopic,
        resources: [...(selectedTopic.resources || []), ...addedResources],
      };
      fetchTopicWithResources(selectedTopic.topic.topic_id);
      setSelectedTopic(updatedTopic);

      setFileInputs([]);
      setSelectedTags([]); 
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; 
      }
    }

    setIsUploading(false);
  } catch (error) {
    console.error('Error adding resources:', error);
    toast.error('Error adding resources');
  } finally {
    setIsUploading(false);
  }
};




// Helper function to determine file type
const determineFileType = (file: File): 'video' | 'audio' | 'pdf' | 'image' => {
  const fileExtension = file.name.split('.').pop()?.toLowerCase();

  if (fileExtension?.match(/(mp4|mov|avi|mkv)/)) {
    return 'video';
  } else if (fileExtension?.match(/(mp3|wav|aac|ogg)/)) {
    return 'audio';
  } else if (fileExtension === 'pdf') {
    return 'pdf';
  } else if (fileExtension?.match(/(png|jpg|jpeg)/)) {
    return 'image';
  }

  throw new Error('Unsupported file type');
};


const fetchTopicWithResources = async (topicId: number) => {
  try {
    const response = await getTopicWithResource(topicId);
    if (response.data) {
      setSelectedTopic(response.data);
      setClickTopicModal(true);
      setIsAddingResources(false);
    } else {
      console.error('Failed to fetch topic with resources:', response.message);
    }
  } catch (error) {
    console.error('Error fetching topic with resources:', error);
  }
};

const handleTopicClick = async (topic: Topic, index: any) => {
  // handleTopicEditSave ();
  setSelectedTopicIndex(index);
  setCurrentView('view_edit_topic');
  setClickTopicModal(true);
  setUpdatedDescription(topic.description);
  setTopicName(topic.topic_name);
  setTopicNumber(topic.topic_number);
  setIsExtended((topic as any).is_extended);
  setArtiumGrade((topic as any).artium_grade);
  setTrinityGrade((topic as any).trinity_grade);
  await fetchTopicWithResources(topic.topic_id);
};

 

  const handleTopicEdit = () => {
    setIsEditingDescription(true);
  };


  const onSaveDescription = (description: any) => {
    // Your logic to handle saving the description
  };
  

  const handleTopicEditSave = async () => {
    // Save the updated description
    let res = await editTopic((selectedTopic as any)?.topic.topic_id,{   
      lessonId: expandedLesson,
      description: updatedDescription,
      topicName: topicName,
      topicNumber: topicNumber,
      isExtended: isExtended,
      artiumGrade: artiumGrade,
      trinityGrade: trinityGrade
    });
    if(res.status == 200){
      toast.success('Topic updated successfully');
      fetchTopics(expandedLesson);
      setIsEditingDescription(false);
    } else {  
      //alert('Error updating topic');
    }
    //onSaveDescription(updatedDescription);
    //setIsEditingDescription(false);
  };

  const handleEditTopicCancel = () => {
    setCurrentView("");
    setIsEditingDescription(false);
  };

  const handleTopicCancel = () => {
    setClickTopicModal(false); // Close the modal/resource section
    setCurrentView("");
  };

  

  const handleAddTopic = (lessonNumber: number) => {
    setCurrentView('view_add_topic');
    setIsAddingTopic(true);
  };

  const handleAddLessonClick = () => {
    setCurrentView('view_add_song');
    setIsAddingLesson(true);
  };

  
  
  const handleSaveLesson = async (newLesson: any) => {
    setIsUploading(true);
  
    try {
      const reqParam = {
        levelId: activeTab,
        lessonNumber: newLesson.lessonNumber,
        lessonName: newLesson.name,
        summary: newLesson.summary,
        objective: newLesson.objective,
        lessonProcedure: newLesson.lessonProcedure,
        lessonClosure: newLesson.lessonClosure,
        outcome: newLesson.learningOutcomes,
        tags: newLesson.lessongTags,
        procedureId: newLesson.procedureId, // Use the uploaded procedure ID
      };
  
      const response = await addLesson(reqParam);
      if (response.status === 201) {
        toast.success("Lesson added successfully");
        setLessons((prevLessons: any[]) => [...prevLessons, newLesson]);
        setIsAddingLesson(false);
        await fetchLessons();
      } else {
        toast.error(`Failed to add lesson: ${response.data?.message || "Unknown error occurred"}`);
      }
    } catch (error) {
      console.error("Error adding lesson:", error);
      toast.error("Error adding lesson.");
    } finally {
      setIsUploading(false);
    }
  };
  
  
  

  const handleSaveAssignment = async (assignments: any) => {
    if (selectedTopic || savedTopic) {
      let reqParam = {
        "topicId": (selectedTopic as any)?.topic_id || (savedTopic as any)?.topic_id,
        "name": assignments.name,
        "description": assignments.instructions,
        "resources": assignments.resources.map((resource: any) => ( resource.resource_id))
      };

      // const updatedAssignments = [...(selectedTopic.resources || []), ...assignments.resources];
      // setSelectedTopic({
      //   ...selectedTopic,
      //   resources: updatedAssignments,
      // });

      try {
        const response = await addAssignment(reqParam);
        if (response.status === 201) {
          console.log('Assignment added successfully');
        } else {
          console.error('Failed to add assignment:', response.data.message);
        }
      } catch (error) {
        console.error('Error adding assignment:', error);
      }
    }
    setIsAddingAssignment(false);
  };

  const handleSaveTopic = async ( topicNumber: any,topicName: string, details: string, resources:any,isExtended: boolean, artiumGrade: boolean, trinityGrade: boolean) => {
    let _resources = [];
    _resources = resources.map((resource: any) => {
      // return {
      //   resourceName: resource.resourceName,
      //   type: resource.type,
      //   description: "A video tutorial on lms basics.",
      //   url: ""
      // }
      return resource.resource_id;
    });
    let reqParam = {
      "topicData": {
        "topicName": topicName,
        "topicNumber": topicNumber,
        "description": details,
        "lessonId": expandedLesson,
        "isExtended":!!isExtended,
        "artiumGrade":!!artiumGrade,
        "trinityGrade":!!trinityGrade
      },
      "resources": _resources
    }
    try {
      const response = await addTopic(reqParam);
      if (response.status === 200) {
      setSavedTopic(response.data.topic);
      toast.success ('Topic added successfully');
      fetchTopics(expandedLesson, response.data.topic); // Refresh topics after adding a new one
      //setIsAddingTopic(true);
      setIsAddingTopic(false);

      } else {
      console.error('Failed to add topic:', response.data.message);
      }
    } catch (error) {
      console.error('Error adding topic:', error);
    }
  };

  const handleSaveResource = (updatedResource: Resource) => {
    if (selectedTopic) {
   
      const updatedResources = selectedTopic.resources?.map((res: Resource) =>
        res.resource_id === updatedResource.resource_id ? updatedResource : res
      );
  
    
      setSelectedTopic({ ...selectedTopic, resources: updatedResources });
    }
  };
  



  const toggleLesson = (lesson: any) => {
    if (expandedLesson === lesson.lesson_id) {
      setExpandedLesson(null);
      setTopics([]);
    } else {
      setExpandedLesson(lesson.lesson_id);
      fetchTopics(lesson.lesson_id); // Fetch topics for the selected lesson
    }
  };
  const proxyUrl = `https://your-proxy-server.com/${encodeURIComponent(procedureUrl)}`;


  const handleDisplayNameChange = (index: number, newDisplayName: string) => {
    
    setFileInputs(prevInputs => {
      const updatedInputs = [...prevInputs];
      updatedInputs[index].displayName = newDisplayName;
      return updatedInputs;
    });
  };

  const handleCheckboxChange = async (resource_id: any) => {
    const reqParam = {
      topicId: selectedTopic.topic.topic_id,
    };

    try {
      const response = await isDownloadable(resource_id, reqParam);
      if (response.status === 200) {
        toast.success('Downloadable State Updated');
        // Refresh the topic/resources to update the UI
        fetchTopicWithResources(selectedTopic.topic.topic_id);
      } else {
        toast.error('Failed to update resource:', response.data.message);
      }
    } catch (error) {
      console.error('Error updating resource:', error);
    }
  };

  const deleteResource = async (topicId: any, resource_id: any) => {
   
   

    try {
      const response = await removeTopicResource(topicId, resource_id);
      if (response.status === 200) {
       toast.success('Resource removed successfully');
        const updatedResources = selectedTopic.resources.filter((res: Resource) => res.resource_id !== resource_id);
        setSelectedTopic({ ...selectedTopic, resources: updatedResources });
      } else {
      toast.error('Failed to remove resource:', response.data.message);
      }
    } catch (error) {
      console.error('Error removing resource:', error);
    }
  };
  const deleteAssignment = async () => {
    if (!assignmentToDelete) return;
  
    const { topicId, assignmentId } = assignmentToDelete;
  
    try {
      console.log('Deleting assignment:', assignmentId);
      let response = await deleteAssignmentFromTopic(topicId, assignmentId);
      if (response.status === 200) {
        fetchTopicWithResources(topicId);
        toast.success('Assignment deleted successfully');
      } else {
        console.error('Error deleting assignment:', response);
        toast.error('There was an error deleting the assignment. Please try again.');
      }
    } catch (error) {
      console.error('Error deleting assignment:', error);
      toast.error('There was an error deleting the assignment. Please try again.');
    } finally {
      closeDeleteModal(); 
    }
  };
  

  const toolbarOptions = [
    [{ font: [] }], // Font family
    [{ script: "sub" }, { script: "super" }], // Subscript/Superscript
    ["bold", "italic", "underline", "strike"], // Text styling
    [{ list: "ordered" }, { list: "bullet" }], // Lists
    [{ color: [] }, { background: [] }], // Font color and background
    ["link"], // Links
  ];


  return (
    <Container fluid>
     <Row className="user-cards-items user-card-wrapper" >
  <Col md="12">


    <div style={{marginTop:"10px", cursor: 'pointer',}}>
 
      {/* Navigation Tabs */}
<Nav tabs style={{ marginBottom: '20px' }}>
  {courseDetail.levels
    .slice()
    .sort((a: any, b: any) => {
      const orderA = courseLevels.findIndex((level:any) => level.name === a.level_name);
      const orderB = courseLevels.findIndex((level:any) => level.name === b.level_name);
      return orderA - orderB;
    }) // Sort by predefined courseLevels order
    .map((level: any) => (
      <NavItem key={level.level_id}>
        <NavLink
          className={classnames({ active: activeTab === level.level_id, default_border: activeTab === level.level_id })}
          onClick={() => toggleTab(level.level_id)}
        >
          {level.level_name}
        </NavLink>
      </NavItem>
    ))}
  <Button onClick={toggleAddLevelModal}>
    <Plus size={17} />
  </Button>
</Nav>


      <AddLevelModal
      setCourses={setCourses}
      courseDetail={selectedCourse}
      setSelectedCourse={setSelectedCourse}
        isOpen={isAddLevelModalOpen}
        toggle={toggleAddLevelModal}
        courseName={updatedCourseDetail.course_name}
        courseId={updatedCourseDetail.course_id}
        existingLevels={updatedCourseDetail.levels}
        allLevels={courseLevels}
        onLevelsAdded={updateCourseLevels} 
      />


      {/* Loader: Show while switching tabs */}
      {isLoading ? (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Spinner color="secondary" />
        </div>
      ) : (
        <div>
          {/* Render the content of the active tab */}
    

          <H4 style={{ marginTop: "10px" }}>
  {courseDetail.course_name} -{' '}
  {
    // Find the level by activeTab and display its name
    courseDetail.levels.find((level: any) => level.level_id === activeTab)?.level_name
  }
  {
    // Get the level_id for the active tab
    courseDetail.levels.find((level: any) => level.level_id === activeTab) && (
      <a
        href={`https://uatreact.artiumacademy.com/videocall/${
          courseDetail.levels.find((level: any) => level.level_id === activeTab)?.level_id
        }`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button
          className={classnames('custom-cancel-button')}
          color="secondary"
          style={{ marginLeft: "10px" }}
        >
          Preview
        </Button>
      </a>
    )
  }
</H4>

  




         
    <Row className="user-cards-items user-card-wrapper">
        <Col>
          {/* <h4>{courseDetail.course_name} - {activeTab}</h4> */}
        </Col>
      </Row>
     
      <Row className="user-cards-items user-card-wrapper">
     
        <Col md="3" className="side-menu bar" style={{ maxHeight: '80vh', overflowY: 'auto', marginTop: '30px' }}>
        {/* <Card >
            <CardBody onClick={handleAddSongClick}>
              <H6 style={{ cursor: 'pointer' }}>Song list</H6>
            </CardBody>
          </Card> */}
        <Card  color='primary' onClick={handleAddLessonClick} style={{marginBottom:"10px", textAlign:"center" }}>
            Add Lesson +
          </Card>
          <Card
  className={classnames({ 'highlighted-button': currentView == "view_level_song"})}  // Apply 'highlighted-button' conditionally
  style={{ marginBottom: '10px', textAlign: 'center', cursor: 'pointer' }}
  onClick={handleAddSongClick}
>
  Song List
</Card>
          {lessons.map((lesson: any) => (
            <Card key={lesson.lesson_id} className="mb-3 card">
              <CardBody>
              <div style={{ position: 'absolute', top: '-5px', left: '-20px' }}>
              <Button 
          color="link" 
          onClick={() => handleEditLesson(lesson.lesson_id)} 
        >
          <CiEdit size={22} />
        </Button>
      </div>

   
            
            
                <h5 onClick={() => toggleLesson(lesson)} style={{ cursor: 'pointer' }}>
                  Lesson {lesson.lesson_number}
                  {/* <ChevronDown style={{   marginLeft: '8px', verticalAlign: 'middle', transform: expandedLesson === lesson.lesson_id?  'rotate(180deg)' : 'rotate(0)' }}/> */}

<Button
          color="link"
          onClick={toggleLesson}
          style={{ float: 'right', padding: '0', textDecoration: 'none' }}
        >
          {expandedLesson === lesson.lesson_id? '▼' : '►'}
        </Button>

                  <h6>{lesson.lesson_name}</h6>
                </h5>

                <Collapse isOpen={expandedLesson === lesson.lesson_id}>
                  {topics.map((topic: any, topicIndex: number) => (
                    <div key={topicIndex}>
                 <Card 
  onClick={() => handleTopicClick(topic, topicIndex)}
  className={classnames({ default_border: selectedTopicIndex === topicIndex })}
  style={{
    cursor: 'pointer',
    marginBottom: '1rem',
    marginTop: '10px'
  }}
>
  <CardBody>
    <h6>
      <b>Topic Number: </b>{topic.topic_number} {/* Display topic number */}
      <br />
      <b>Topic Name: </b>{topic.topic_name}
    </h6>
  </CardBody>
</Card>

                    </div>
                  ))}
                  <Button color="primary" onClick={() => handleAddTopic(lesson.lesson_id)} style={{ marginTop: '1rem' }}>
                    Add Topic +
                  </Button>
                </Collapse>
              </CardBody>
            </Card>
          ))}

      
        </Col>

        <Col md="9" style={{ padding: '2rem' }}>
        {isEditing  &&  currentView == "view_edit_Lesson" && (
  <Card className="mb-3">
    <CardBody style={{ maxHeight: '65vh', overflowY: 'auto' }}>
      <h2  style={{color:"#e82c86"}} >Edit Lesson</h2>
      <h6  color="primary"  style={{ marginBottom: '10px', marginTop:"15px"  }}>
        <b>Lesson Number:</b>
        <Input 
          style={{ marginTop: '10px' }} 
          type="text" 
          value={lessonNumber} 
          onChange={(e) => setLessonNumber(e.target.value)} 
        />
      </h6> 

      <h6 style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <b>Lesson Name:</b>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <PiStudentDuotone size={20} style={{ marginRight: '5px' }} />
          <LiaChalkboardTeacherSolid size={20} />
        </div>
      </h6>
      <Input
        style={{ marginTop: '10px' }}
        type="text"
        id="lessonName"
        value={lessonName}
        onChange={(e) => setLessonName(e.target.value)}
      />

      <h6 style={{ marginBottom: '10px', marginTop:"10px" }}>
        <b>Lesson Summary:</b>
        <ReactQuill 
      modules={{
        toolbar: toolbarOptions,
      }}
      formats={[
        "font",
        "script",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "color",
        "background",
        "link",
      ]}
        style={{ marginTop: '10px' }} value={summary} onChange={setSummary}  />
      </h6>

      <h6 style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <b> Learning Objective:</b>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <PiStudentDuotone size={20} style={{ marginRight: '5px' }} />
          <LiaChalkboardTeacherSolid size={20} />
        </div>
      </h6>
      <ReactQuill
     modules={{
      toolbar: toolbarOptions,
    }}
    formats={[
      "font",
      "script",
      "bold",
      "italic",
      "underline",
      "strike",
      "list",
      "bullet",
      "color",
      "background",
      "link",
    ]}
        style={{ marginTop: '10px' }}
        value={lessonObjective}
        onChange={setLessonObjective}
      />

<FormGroup>
  <h6
    style={{
      marginBottom: '10px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '10px',
    }}
  >
    <b>Lesson Procedure:</b>
    <LiaChalkboardTeacherSolid size={20} />
  </h6>

      <ReactQuill
     modules={{
      toolbar: toolbarOptions,
    }}
    formats={[
      "font",
      "script",
      "bold",
      "italic",
      "underline",
      "strike",
      "list",
      "bullet",
      "color",
      "background",
      "link",
    ]}
        style={{ marginTop: '10px' }}
        value={lessonProcedure}
        onChange={setLessonProcedure}
      />
</FormGroup>

<FormGroup>
  <Label
    for="lessonProcedure"
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '10px',
    }}
  >

<div>  <b>Procedure File:</b>
</div>

    <div style={{ display: 'flex', alignItems: 'center' }}>
 <LiaChalkboardTeacherSolid size={20} />
    </div>
    
  </Label>
<div style={{marginLeft:"-30px"}}>  {procedureUrl && (
  <Button color="secondary" style={{color:"#e82c86",}} onClick={handleToggleModal}>
  <FileText size={16} /> View Procedure 
</Button>)}</div>
  <Input
    type="file"
    id="ProcedureFile"
    required
    accept=".pdf"
    onChange={(e) => {
      const file = e.target.files?.[0]; // Get the selected file
      if (file) {
        console.log('Selected File:', file);
        setProcedureFile(file); // Update state with the selected file
      } else {
        setProcedureFile(null); // Clear state if no file is selected
      }
    }}
  />
</FormGroup>
<Modal isOpen={isLessonModalOpen} toggle={handleToggleModal}>
  <ModalHeader toggle={closeLessonModal}>View Procedure</ModalHeader>
  <ModalBody>
    {procedureUrl ? (
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>

            <div style={{ height: '600px' }}>
                  <Viewer
          fileUrl={procedureUrl}
          withCredentials={false}
        />
         
          </div>
      </Worker>
    ) : (
      <p>No procedure file available to preview.</p>
    )}
  </ModalBody>
  <ModalFooter>
    <Button color="secondary" onClick={closeLessonModal}>
      Close
    </Button>
  </ModalFooter>
</Modal>
      <h6 style={{ marginBottom: '10px', marginTop:"10px" }}>
        <b>Lesson Closure:</b>
        <ReactQuill style={{ marginTop: '10px' }} 
      modules={{
        toolbar: toolbarOptions,
      }}
      formats={[
        "font",
        "script",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "color",
        "background",
        "link",
      ]}
        value={lessonClosure} onChange={setLessonClosure} />
      </h6>

      <h6 style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop:"10px"}}>
        <b>Learning Outcomes:</b>
        <LiaChalkboardTeacherSolid size={20} />
        </h6>


        <ReactQuill style={{ marginTop: '10px' }} 
        modules={{
          toolbar: toolbarOptions,
        }}
        formats={[
          "font",
          "script",
          "bold",
          "italic",
          "underline",
          "strike",
          "list",
          "bullet",
          "color",
          "background",
          "link",
        ]}
        value={learningOutcomes} onChange={setLearningOutcomes} />
  <h6 style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop:"10px"}}>
        <b>Tags:</b>
    
        </h6>
        <Select
  isMulti
  value={(lessongTags || []).map((tagName: any) => ({ value: tagName, label: tagName }))} // Provide default value
  options={LessonTagOptions || []}
  onChange={(selected) => setLessongTags(selected.map((tag) => tag.value))} // Store only names
  placeholder="Select tags"
/>

  

<span style={{marginTop:"10px"}}>     <b>Rubrics:</b></span>
<div 
  style={{
    marginTop: '10px',
    border: '1px solid lightgray',  
    padding: '10px',           
  }}
>
  <div 
    style={{
      maxHeight: '70vh',
      overflowY: 'auto',
    }}
  >  
    <h6 
      style={{
        marginBottom: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <LessonRubrics
        courseDetail={courseDetail}
        lessonId={currentLessonId}
        // Optional chaining to prevent errors
      />
    </h6>
  </div>
</div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
      <Button color="primary" onClick={handleSave}>
  Save
</Button>

        <Button className="custom-cancel-button" onClick={() => setIsEditing(false)}  toggle={() => setCurrentView("")} >
          Cancel
        </Button>
      </div>
    </CardBody>
  </Card>
        )}



{selectedTopic && currentView == "view_edit_topic" && (
        <Card className="mb-3" style={{ maxHeight: '80vh', overflowY: 'auto', marginTop: '10px' }}>
              <Button onClick={handleTopicCancel} style={{ marginTop: '20px',  color: "#e82c86", justifyContent:"flex-end", display:"flex" }}>
            <MdOutlineCancel size={24} />
            </Button>
          <CardBody>
     
            <Card>
          
              <CardBody style={{ maxHeight: '80vh', overflowY: 'auto', marginTop: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <h3 style={{ margin: 0 }}>
                  {/* <b>Topic:</b> {topicNumber} */}
                    
                    <b>Topic:</b> {topicName}
                  </h3>
                  <Button color="link" onClick={handleTopicEdit} style={{ marginLeft: '10px' }}>
                  <CiEdit size={24} />
                  </Button>
                </div>

                {/* Description Section */}
                <div style={{ marginTop: '10px' }}>
                  {/* <b>Description: </b> */}

                  {/* If editing, show the rich text editor */}
                  {isEditingDescription ? (
                    <div>
                                            <FormGroup>
  <Label for="topicNumber" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <b>Topic Number:</b>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <PiStudentDuotone size={20} style={{ marginRight: '5px' }} />
      <LiaChalkboardTeacherSolid size={20} />
    </div>
  </Label>
  <Input
    type="number"
    id="topicNumber"
    value={topicNumber}
    onChange={(e) => setTopicNumber(e.target.value)}
  />
</FormGroup>
                      <FormGroup>
  <Label for="topicName" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <b>Topic Name:</b>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <PiStudentDuotone size={20} style={{ marginRight: '5px' }} />
      <LiaChalkboardTeacherSolid size={20} />
    </div>
  </Label>
  <Input
    type="text"
    id="topicName"
    value={topicName}
    onChange={(e) => setTopicName(e.target.value)}
  />
</FormGroup>
<FormGroup>
  <Label style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <b>Description:</b>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <PiStudentDuotone size={20} style={{ marginRight: '5px' }} />
      <LiaChalkboardTeacherSolid size={20} />
    </div>
  </Label>
  <ReactQuill 
 modules={{
  toolbar: toolbarOptions,
}}
formats={[
  "font",
  "script",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "color",
  "background",
  "link",
]}
    value={updatedDescription}
    onChange={setUpdatedDescription}
    style={{ marginBottom: '10px' }}
  />
</FormGroup>

                      {/* Additional Checkboxes */}
        <FormGroup>
          <Label>Additional Options:</Label>
          <Row form>
            <Col md={4}>
              <Input
                type="checkbox"
                checked={isExtended}
                className='levelChk'
                onChange={(e) => setIsExtended(e.target.checked)}
              />
              <Label style={{ marginLeft: '10px' }}> Is Extended</Label>
            </Col>
          
          </Row>
        </FormGroup>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                        <Button color="primary" onClick={handleTopicEditSave} style={{ marginRight: '10px' }}>
                          Save
                        </Button>
                        <Button className="custom-cancel-button" onClick={handleEditTopicCancel}>
                          Cancel
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {/* Display the description in HTML format */}
                      <span dangerouslySetInnerHTML={{ __html: updatedDescription }} />
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>

            {/* Resources Section */}
            <Card>
              <CardBody style={{ maxHeight: '80vh', overflowY: 'auto', marginTop: '10px' }}>
                <div onClick={toggle} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                  <h5>
                    Resources <ChevronDown style={{ marginLeft: '8px', verticalAlign: 'middle', transform: isOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
                  </h5>
                </div>

                <Collapse isOpen={isOpen}>
                <div>
     <div>
     {selectedTopic.resources?.map((resource: Resource, index: number) => (
  <ReplaceableResourceCard
    key={index}
    resource={resource}
    // selectedTags={setSelectedTags}
onChecked={()=> handleCheckboxChange(resource.resource_id)}
    onDelete={() => deleteResource(selectedTopic.topic.topic_id, resource.resource_id)}
    onSave={handleSaveResource}
    fetchTopicWithResources={() => fetchTopicWithResources(selectedTopic.topic.topic_id)}
    />
))}
  </div>
    </div>   <div>
   

                  <Modal isOpen={isFileModalOpen} toggle={toggleFileModal}>
  <ModalHeader toggle={toggleFileModal}>Add Existing Resources</ModalHeader> {/* Pass the correct toggle function */}
  <ModalBody>
    {/* Add any existing resources list here, e.g., a list or table */}
    <Search
      selectedTopic={selectedTopic}
      handleAddExistingResourceToTopic={handleAddExistingResourceToTopic}
      setResources={setResources}
    />
  </ModalBody>
</Modal>

      {/* </Card> */}
    </div>
                  <Card style={{ marginTop: "10px" }}>
                    <CardBody>
                      {/* <h5>Add New Resources</h5> */}
                      <div >
                        {/* <FormGroup style={{ flex: 1, marginRight: '10px' }}>
                          <Label for="displayName">Display Name</Label>
                          <Input
                            type="text"
                            placeholder="Display Name (optional)"
                            value={displayName}
                            onChange={(e) => setDisplayName(e.target.value)} // Allow user to change display name
                          />
                        </FormGroup> */}
                        <FormGroup style={{ flex: 1, marginRight: '10px' }}>
                          <Label for="fileUpload">Choose File</Label>
                          <input
                              ref={fileInputRef}
                            type="file"
                            id="fileUpload"
                            onChange={handleFileChange} // Call file change handler
                            multiple
                            accept="video/*,audio/*,application/pdf,image/png,image/jpeg"
                                                        className="form-control"
                          />
                           {fileInputs.map((input, index) => (
              <div key={index} style={{ marginTop: '10px' }}>
                {/* <p>{input.file.name}</p> */}
                <Input
                  type="text"
                  value={input.displayName}
                  onChange={(e) => handleDisplayNameChange(index, e.target.value)}
                  placeholder="Display Name"
                />
              </div>
            ))}
                        </FormGroup>
                        <FormGroup style={{ marginTop: '20px' }}>
      <label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Select Tags</label>
      <Select
  isMulti
  options={tagOptions} // Tag options provided from `tagsMap`
  value={tagOptions.filter(option => selectedTags.includes(option.value))} // Ensure controlled component
  onChange={(selectedOptions) => {
    setSelectedTags(selectedOptions?.map((option) => option.value) || []);
  }}
  placeholder="Choose tags for resources"
/>

    </FormGroup>

                        <Button 
  color="primary" 
  onClick={handleAddResources}
  style={{ marginTop: "6px" }}
  disabled={isUploading}
>
  {isUploading ? <Spinner size="sm" /> : 'Add Resources'}
</Button>


{/* <Button
                          style={{ marginTop: "6px" }}
                          color="primary"
                          onClick={handleAddResources}
                        >
                          Save Resources
                        </Button> */}
        
          
                      </div>
                  <div style={{display:"flex", justifyContent:"center",}} >    <H5  >Or</H5></div>

    <div style={{display:"flex", justifyContent:"center" ,marginTop:"10px"}}>                  <Button className={classnames('custom-cancel-button')} 
      onClick={toggleFileModal}
        >
        Add Existing Resources
        </Button></div>
                  
                    </CardBody>
               
                  </Card>
                </Collapse>
  
              </CardBody>
              {/* {resources.map((resource, index) => (
              <li key={index}>
                {resource.type.toUpperCase()}: {resource.name || (resource as any).display_name ||(resource as any).resource_name }
              </li>
            ))} */}
            </Card>
  

            {/* Assignments Section */}
            <Card style={{ marginTop: "10px" }}>
              <CardBody>
                <div>
                  <div onClick={toggleCollapse} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                    <h5>
                      Assignments <ChevronDown style={{ marginLeft: '8px', verticalAlign: 'middle', transform: isOpenAssign ? 'rotate(180deg)' : 'rotate(0)' }} />
                    </h5>
                  </div>

                  <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal}>
  <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
  <ModalBody>
    Are you sure you want to delete this assignment?
  </ModalBody>
  <ModalFooter>
    <Button color="danger" onClick={deleteAssignment}>Delete</Button>
    <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
  </ModalFooter>
</Modal>


                  <Collapse isOpen={isOpenAssign}>
                
                   
                        {/* AddAssignmentCard Component */}
                        <AddAssignmentCard
                        deleteAssignment={deleteAssignment}
                        openDeleteModal={openDeleteModal}
                      topicId={selectedTopic.topic.topic_id}
                      lessonId={selectedTopic.topic.lesson_id}
                      onSave={(newAssignments) => {
                        // handleSaveAssignment(newAssignments);
                        fetchTopicWithResources(selectedTopic.topic.topic_id);
                      }}
                      onCancel={() => toggleCollapse()} // Close collapse on cancel
                      //toggle={() => toggleCollapse()}
                      existingResources={selectedTopic.resources || []} // Pass existing resources for reuse
                      topic={selectedTopic || {}} // Pass the entire topic object if needed elsewhere
          
                      courseId={courseDetail.course_id}
                    />

                 
                  </Collapse>
                </div>
              </CardBody>
            </Card>

            <Button className="custom-cancel-button" onClick={handleTopicCancel} style={{ marginTop: '20px' }}>
              Cancel
            </Button>
            
          </CardBody>
        </Card>
      )}
   


          {isAddingResources && !isAddingAssignment && <AddResourceCard onSave={()=>{}}toggle={() => setCurrentView("")}  />}

          {currentView == "view_level_song" && <SonglistCard levelId={activeTab} toggle={() => setCurrentView("")} />} 

          {currentView == "view_add_topic" && <AddTopicCard savedTopic={savedTopic} onSaveAssignment={handleSaveAssignment} toggle={() => setCurrentView("")} onSaveTopic={handleSaveTopic} />}

          {currentView == "view_add_song" && (
  <AddLessonModal

    isOpen={isAddingLesson}
    toggle={() => setCurrentView("")}
    onSave={handleSaveLesson}
// Pass the courseDetail prop
  />
)}

        </Col>
      </Row>
        </div>
      )}

    </div>

   
  </Col>
</Row>


 
    </Container>
  );
};

export default ArtiumCourseManager;
